import { NgModule } from '@angular/core';
import { LayoutModule } from '../../../../kendo/kendo-angular-layout/layout.module';
import { PanelBarModule } from '@progress/kendo-angular-layout';
import { TiSplitterModule } from './ti.splitter.module';
import { TabStripModule } from '@progress/kendo-angular-layout';

/**
 * Represents the [NgModule](https://angular.io/docs/ts/latest/guide/ngmodule.html)
 * definition for the Layout components.
 *
 * @example
 *
 * ```ts-no-run
 * // Import the Layout module
 * import { LayoutModule } from '@progress/kendo-angular-layout';
 *
 * // The browser platform with a compiler
 * import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
 *
 * import { NgModule } from '@angular/core';
 *
 * // Import the app component
 * import { AppComponent } from './app.component';
 *
 * // Define the app module
 * _@NgModule({
 *     declarations: [AppComponent], // declare app component
 *     imports:      [BrowserModule, LayoutModule], // import Layout module
 *     bootstrap:    [AppComponent]
 * })
 * export class AppModule {}
 *
 * // Compile and launch the module
 * platformBrowserDynamic().bootstrapModule(AppModule);
 *
 * ```
 */
@NgModule({
  imports: [LayoutModule],
  exports: [PanelBarModule, TiSplitterModule, TabStripModule],
})
export class TiLayoutModule {}
